'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FooterItem = require('./FooterItem');

var _FooterItem2 = _interopRequireDefault(_FooterItem);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
  var _ref$sites = _ref.sites,
      sites = _ref$sites === undefined ? [] : _ref$sites;

  var items = sites.map(function (item, i) {
    return _react2.default.createElement(_FooterItem2.default, { key: i, url: item.url, title: item.title });
  });

  return _react2.default.createElement(
    'footer',
    { className: 'app footer inverted' },
    _react2.default.createElement(
      'div',
      { className: 'ui stackable menu container inverted' },
      items
    )
  );
};

Footer.propTypes = {
  sites: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    url: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }))
};

exports.default = Footer;


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/lib/theme/Footer.js
// module id = 515
// module chunks = 0